import { App } from './app.class';
import { Modal } from './modal.class';
import { Notification } from './notification.class';
import { Fetch } from '../fetch.class';

export class Referrerdomains {

    // Initialisieren
    constructor(selector, storing=false, form_code='') {

        // Hauptelement
        this.$ele = document.querySelector(selector);

        // direkte Speicherung
        this.storing = storing;
        this.form_code = form_code;

        // Vars
        this.id = this.$ele.getAttribute('id');
        this.modalAddSelector = '#'+this.id+' .modal';

        // Elemente
        this.$list = this.$ele.querySelector('ul.list');
        this.$listLiEmpty = this.$list.querySelector('li.empty');
        this.$value = this.$ele.querySelector('input[type=hidden]');
        this.$btnAdd = this.$ele.querySelector('.cont button');
        this.$modalBtnApply = this.$ele.querySelector(this.modalAddSelector+' button.apply');
        this.$modalError = this.$ele.querySelector(this.modalAddSelector+' .error');
        this.modal = new Modal(this.modalAddSelector);

        // Öffnen des Modal
        this.$btnAdd.addEventListener('click', event => {
            this.modal.show();
        });

        // Domain übernehmen
        this.$modalBtnApply.addEventListener('click', event => {
            const $input = this.$ele.querySelector(this.modalAddSelector+' input[type=text]');
            if($input) {
                this.addDomain( $input.value );
            }
        });

        this.updateList();
    }

    // Anzeige der Liste aktualisieren
    updateList() {

        // Liste der Domains
        const domains = this.getDomains();

        // vorhandene Einträge entfernen
        const entries = this.$list.querySelectorAll('li.entry');
        entries.forEach(el => {
            el.parentNode.removeChild(el);
        });

        // keine Domains gewählt
        if(domains.length === 0) {
            this.$listLiEmpty.style.display = 'flex';
        }

        // Adressen vorhanden
        else {
            this.$listLiEmpty.style.display = 'none';
            domains.forEach(address => {
                const element = document.createElement('li');
                element.classList.add('entry');

                let html = '';
                html += '    <div>';
                html += '        <svg fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" stroke="currentColor" viewBox="0 0 24 24"><path d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>';
                html += '        <span>'+address+'</span>';
                html += '    </div>';
                html += '    <div>';
                html += '        <button type="button">';
                html += '            <svg fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" stroke="currentColor" viewBox="0 0 24 24" class="h-5 w-5 inline"><path d="M6 18L18 6M6 6l12 12"></path></svg>';
                html += '        </button>';
                html += '    </div>';

                element.innerHTML = html;

                element.querySelector('button').addEventListener('click', event => {
                    const $span = element.querySelector('span');
                    this.removeDomain($span.textContent);
                });

                this.$list.appendChild(element);
            });
        }
    }

    // liefert Liste der aktuelle gewählten Domains
    getDomains() {

        // Liste der Domains
        let domains = this.$value.value.split(",");
        domains.forEach((domain, i) => {
            if(domain === "")
                domains.splice(i, 1);
        });

        return domains;
    }

    // Domain hinzufügen
    addDomain(domain) {

        // Fehler ausblenden
        this.$modalError.classList.add('hidden');

        // Eingabefeld
        const $input = this.$ele.querySelector(this.modalAddSelector+' input[type=text]');

        // bei Fehler
        const error_function = (msg) => {

            // Fehlermeldung anzeigen
            this.$modalError.querySelector('.cont').textContent = msg;
            this.$modalError.classList.remove('hidden');

            // Fokus auf Eingabe
            $input.focus();
        }

        // bei Erfolg
        const success_function = (add_domain) => {

            // Eingabe leeren
            $input.value = '';

            // Hinzufügen
            let domains = this.getDomains();
            domains.push(add_domain);
            this.$value.value = domains.join(',');
            this.updateList();
            this.modal.close();
        }

        if(!this.storing) {

            // Ist bereits in Liste
            const domains = this.getDomains();
            if(domains.includes(domain)) {
                this.modal.close();
                return;
            }

            // Domain überprüfen
            const data = new FormData();
            data.append("domain", domain);
            new Fetch().post(App.getUrl('form', 'validate_referrerdomain'), data)
            .then(response => {
                if(response.domain) {

                    if(domains.includes(response.domain)) {
                        this.modal.close();
                        return;
                    }

                    success_function(response.domain);
                }
            })
            .catch(error => {
                error_function( error.message );
            });
        }

        else {

            // Domain eintragen
            const data = new FormData();
            data.append("form_code", this.form_code);
            data.append("domain", domain);
            new Fetch().post(App.getUrl('form', 'add_referrerdomain'), data)
            .then(response => {
                console.log(response);
                if(response.domain) {
                    success_function(response.domain);
                }
            })
            .catch(error => {
                error_function( error.message );
            });
        }
    }

    // Domain aus Liste entfernen
    removeDomain(domain) {

        // bei Erfolg
        const success_function = () => {

            const domains = this.getDomains();
            let newList = [];
            domains.forEach(a => {
                if(a !== domain)
                    newList.push(a);
            });
            this.$value.value = newList.join(',');
            this.updateList();
        }

        if(!this.storing) {
            success_function();
        }

        else {
            const data = new FormData();
            data.append("form_code", this.form_code);
            data.append("domain", domain);

            // Meldungen ausblenden
            new Notification().hideAll();

            // Senden
            new Fetch().post(App.getUrl('form', 'remove_referrerdomain'), data)
            .then(response => {
                success_function();
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                new Notification().error(error.message);
            });
        }
    }
}